import { Delete24Regular } from "@fluentui/react-icons";
import { Button } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

import styles from "./ClearChatButton.module.css";

interface Props {
    className?: string;
    onClick: () => void;
    canClear?: boolean;
}

export const ClearChatButton = ({ className, canClear = false, onClick }: Props) => {
    const { t } = useTranslation();
    if (!canClear) return null; // Hide button if cannot clear
    return (
        <div className={`${styles.container} ${className ?? ""}`}>
            <Button icon={<Delete24Regular />} onClick={onClick}>
                {t("clearChat")}
            </Button>
        </div>
    );
};
